<template>
	<div>
		<v-tabs
			v-model="tab"
			dense
			height="40px"
			slider-color="primary"
			color="black"
		>
			<v-tab> 作業指示書 </v-tab>
			<v-tab> チェックシート </v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab">
			<v-tab-item>
				<h6 class="text-body-1 font-weight-bold mt-4">作業指示書</h6>
				<v-sheet class="mt-4" elevation="0" max-width="600px" width="100%">
					<table width="100%" class="show-dialog-table show-dialog-table--form">
						<tbody>
							<ShowDetailRecord :columnName="'作業指示書名'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										dense
										outlined
										:rules="[]"
										background-color="white"
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'製造番号'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										dense
										outlined
										:rules="[]"
										background-color="white"
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'品名'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										dense
										outlined
										:rules="[]"
										background-color="white"
										hide-details
									/>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'数量'">
								<template v-slot:value>
									<v-text-field
										v-model="TODO"
										dense
										outlined
										:rules="[]"
										background-color="white"
										hide-details
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-sheet>
				<v-sheet class="mt-4" elevation="0" max-width="800px" width="100%">
					<table width="100%" class="mt-4 show-dialog-table">
						<tbody>
							<!-- TODO: trをv-for=""で回す。rowspanを項目数にする データ形式に応じたフォームを用意-->
							<tr>
								<th class="font-weight-bold" style="border-right: 1px solid white" rowspan="3">
									(大枠名)
								</th>
								<th class="font-weight-bold">(項目名)</th>
								<td>
									<v-text-field v-model="TODO" dense outlined :rules="[]" hide-details />
								</td>
							</tr>
							<tr>
								<th class="font-weight-bold">(項目名)</th>
								<td>
									<v-text-field v-model="TODO" dense outlined :rules="[]" hide-details />
								</td>
							</tr>
							<tr>
								<th class="font-weight-bold">(項目名)</th>
								<td>
									<v-text-field v-model="TODO" dense outlined :rules="[]" hide-details />
								</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
			</v-tab-item>
			<v-tab-item>
				<v-row no-gutters>
					<v-col cols="12" sm="6" class="p-auto-1">
						<IncrementalSearchForm
							:label="'製造番号'"
							:classArray="['mt-4']"
							:value.sync="checkSheet.order_individual_info_id"
							:itemText="'get_product_info'"
							:targetName="'製品'"
							:url="`/erp/v1/incremental/order_individual_infos`"
							:params="{ include_params: ['product'] }"
							:initialItems="initialInfos"
							required
							returnObjectWhenEmit
							requireEmit
							@change="changeOrderIndividualInfo($event)"
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<v-text-field
							class="mt-4"
							label="製品名"
							v-model="checkSheet.product_name"
							outlined
							dense
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<v-text-field
							class="mt-4"
							label="図面番号"
							v-model="checkSheet.drawing_number"
							outlined
							dense
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<v-text-field
							class="mt-4"
							label="数量"
							v-model="checkSheet.quantity"
							type="number"
							hide-spin-buttons
							outlined
							dense
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<v-text-field
							class="mt-4"
							label="顧客製造番号"
							v-model="checkSheet.customer_product_number"
							outlined
							dense
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<v-text-field
							class="mt-4"
							label="要領書No."
							v-model="checkSheet.instructions_number"
							outlined
							dense
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<IncrementalSearchForm
							:label="'テンプレート'"
							:classArray="['mt-4']"
							:value.sync="check_sheet.check_sheet_template_id"
							:targetName="'テンプレート'"
							:url="`/erp/v1/incremental/check_sheet_templates`"
							:initialItems="initialTemplates"
							returnObjectWhenEmit
							requireEmit
							returnObject
							@change="changeTemplate"
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<v-text-field
							class="mt-4"
							label="チェックシート名"
							v-model="checkSheet.name"
							outlined
							dense
						/>
					</v-col>
					<v-col cols="12" sm="6" class="p-auto-1">
						<IncrementalSearchForm
							:label="'品証担当者'"
							:classArray="['mt-4']"
							:value.sync="checkSheet.issuer_id"
							:itemText="'full_name'"
							:targetName="'品証担当者'"
							:url="`/erp/v1/incremental/users`"
							:query="{ departments_name_eq: '品質保証部' }"
							:initialItems="initialIssuers"
						/>
					</v-col>
				</v-row>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	components: {
		IncrementalSearchForm,
		ShowDetailRecord,
	},
	props: {
		check_sheet: {
			type: Object,
			required: true,
		},
		order_individual_info: {
			type: null,
			required: false,
			default: null,
		},
		check_sheet_template: {
			type: null,
			required: false,
			default: null,
		},
		issuer: {
			type: null,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			orderIndividualInfo: null,
			checkSheetTemplate: null,
			TODO: null,
			initialInfos: [],
			initialTemplates: [],
			initialIssuers: [],
			tab: 0,
			rules: rules,
			common: common,
			valid: false,
			loading: false,
			error: null,
			matterDialog: false,
		}
	},
	mounted() {
		if (this.order_individual_info) this.initialInfos = [this.order_individual_info]
		if (this.check_sheet_template) this.initialTemplates = [this.check_sheet_template]
		if (this.issuer) this.initialIssuers = [this.issuer]
	},
	methods: {
		changeOrderIndividualInfo(orderIndividualInfo) {
			this.checkSheet.product_name = orderIndividualInfo.ordered_product.product.name
		},
		changeTemplate(template) {
			this.checkSheet.name = template.name
		},
	},
	computed: {
		checkSheet: {
			get() {
				return this.check_sheet
			},
			set(newVal) {
				return this.$emit("update:check_sheet", newVal)
			},
		},
		filteredMeetingAgenda() {
			return this.checkSheet.meeting_agendas_attributes.filter((agenda) => !agenda._destroy)
		},
	},
	watch: {
		order_individual_info(newVal, oldVal) {
			if (newVal === oldVal) return
			this.initialInfos = [newVal]
		},
		check_sheet_template(newVal, oldVal) {
			if (newVal === oldVal) return
			this.initialTemplates = [newVal]
		},
		issuer(newVal, oldVal) {
			if (newVal === oldVal) return
			this.initialIssuers = [newVal]
		},
	},
}
</script>
